import { useRef } from "react";
import { CardContent, Grid, Button } from "@mui/material";
import { FormikProps } from "formik";
import { IActiveModal } from "src/pages/Admin/AdminWindow";
import { CrewDeviceDataGrid } from "./CrewDeviceDataGrid";
import { CrewDeviceInviteModal } from "./BulkInvite";
import { ICrewGroupReleaseSchedule } from "@vmosolutions/oc-interfaces";
interface IManageCrewDevicesProps {
  id: string;
  setActiveModal: (activeModal: IActiveModal | null) => void;
  height: number;
}

export type CrewGroupReleaseScheduleForm = FormikProps<ICrewGroupReleaseSchedule>;

export const ManageCrewDevices = (props: IManageCrewDevicesProps): JSX.Element => {
  const { id, setActiveModal, height } = props;

  /** Get height of the right panel and apply to max menu size */
  const contentRef = useRef<HTMLDivElement>();
  return (
    <CardContent sx={{ height: `calc(${height}px - 100px)` }}>
      <Grid container ref={contentRef} spacing={2}>
        <Grid item xs={12}>
          <CrewDeviceInviteModal />
        </Grid>
        <Grid item xs={12}>
          <CrewDeviceDataGrid setActiveModal={setActiveModal} />
        </Grid>
      </Grid>
    </CardContent>
  );
};
